"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileClientImpl = void 0;
const sfp_types_1 = require("@jetseafoodas/sfp-types");
const HttpClientImpl_1 = require("./HttpClientImpl");
class ProfileClientImpl extends HttpClientImpl_1.HttpClientImpl {
    constructor(options, prefix) {
        super(options);
        this.getProfile = async () => {
            return this.get(`${this.prefix}/`);
        };
        this.updateProfile = async (request) => {
            return this.put(`${this.prefix}/`, request);
        };
        this.updateSelectedFilter = async (filterId) => {
            const request = new sfp_types_1.UserProfileChangeRequest();
            request.selectedFilter = filterId;
            return this.put(`${this.prefix}/`, request);
        };
        this.deleteFilter = async (filterId) => {
            const request = new sfp_types_1.UserProfileChangeRequest();
            request.deleteFilterId = filterId;
            return this.put(`${this.prefix}/`, request);
        };
        this.prefix = `${prefix}/v1/user/profile`;
    }
}
exports.ProfileClientImpl = ProfileClientImpl;
